export default function OrderItem(productId, quantity) {
    this.product = productId;
    this.quantity = quantity;

    Object.freeze(this);
}